import { DEFAULT_CONFETTI_ANIMATION_NAME, ensureConfettiKeyframes } from './ensureConfettiKeyframes';

const DEFAULT_CONFETTI_COLORS = ['#57E3A4', '#FFD66B', '#FF7AB2', '#ffffff', '#7B9FFF', '#FF9A5C', '#ff6b6b'];

export type FireConfettiBurstOptions = {
  originElement?: HTMLElement | null;
  wrapId?: string;
  zIndex?: number;
  particleCount?: number;
  colors?: readonly string[];
  cleanupMs?: number;
  animationName?: string;
};

export const fireConfettiBurst = (options: FireConfettiBurstOptions = {}): (() => void) => {
  const {
    originElement = null,
    wrapId = 'planne-confetti-burst',
    zIndex = 9999,
    particleCount = 120,
    colors = DEFAULT_CONFETTI_COLORS,
    cleanupMs = 3200,
    animationName = DEFAULT_CONFETTI_ANIMATION_NAME,
  } = options;

  if (typeof document === 'undefined') {
    return () => undefined;
  }

  ensureConfettiKeyframes(animationName);

  document.getElementById(wrapId)?.remove();

  const wrap = document.createElement('div');
  wrap.id = wrapId;
  wrap.style.cssText = `position:fixed;inset:0;pointer-events:none;z-index:${zIndex};overflow:visible;`;
  document.body.appendChild(wrap);

  const rect = originElement?.getBoundingClientRect();
  const cx = rect ? rect.left + rect.width / 2 : window.innerWidth / 2;
  const cy = rect ? rect.top + rect.height / 2 : window.innerHeight / 2;

  for (let i = 0; i < particleCount; i += 1) {
    const el = document.createElement('div');
    const color = colors[i % colors.length];
    const w = 3 + Math.random() * 6;
    const h = 2 + Math.random() * 4;
    const delay = Math.random() * 0.4;
    const dur = 1.2 + Math.random() * 1.6;
    const angle = Math.random() * Math.PI * 2;
    const dist = 180 + Math.random() * 340;
    const tx = Math.cos(angle) * dist;
    const ty = Math.sin(angle) * dist - 60;
    const rot = (Math.random() - 0.5) * 1440;
    el.style.cssText = `position:fixed;left:${cx}px;top:${cy}px;width:${w}px;height:${h}px;background:${color};border-radius:1px;animation:${animationName} ${dur}s ease-out ${delay}s forwards;--tx:${tx}px;--ty:${ty}px;--rot:${rot}deg;`;
    wrap.appendChild(el);
  }

  const cleanup = () => {
    wrap.remove();
  };

  window.setTimeout(cleanup, cleanupMs);

  return cleanup;
};
